import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';

import 'react-virtualized/styles.css';
import './App.css';

import MOM from './components/MOM';

const App = ({store}) => (  
  <Provider store={store}>
    <div>
      <Router>
        <MOM />
      </Router>
      <ReduxToastr
        closeButton={false} 
        newestOnTop={true}
        progressBar={false}
        position='top-left'
        preventDuplicates={false}
        timeOut={3000}
        transitionIn='bounceIn'
        transitionOut='fadeOut'
      />
    </div>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js